import { ref } from 'vue'

export enum LoadingReasons {
  embedToken = 'Embed token is missing',
}

export class LoadingReason {
  isLoading = ref(false)
  loadingReasons = new Set<string>()

  constructor(reasons: LoadingReasons[]) {
    reasons.forEach((reason) => {
      this.addReason(reason)
    })
  }

  addReason(reason: LoadingReasons) {
    this.isLoading.value = true
    this.loadingReasons.add(reason)
  }

  removeReason(reason: LoadingReasons) {
    this.loadingReasons.delete(reason)
    if (this.loadingReasons.size === 0) this.isLoading.value = false
  }
}
